import '../../libs/slick/slick-theme.css'

import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'

import { RouteComponentProps, withRouter } from 'react-router'
import { isMobile } from 'react-device-detect'

import { Content } from '../../atoms/Content/index'
import { ContentsView } from './ContentsView'
import { GetOwnIntakeQuery_getOwnIntake, ListContentsQuery_listContents } from '../../schema/schemaTypes'
import { IntakeProgressBar } from '../../molecules/IntakeProgressBar'
import { TrackPageview } from '../TrackPageview/index'
import { intakeMetrics } from '../Intakes/intakeMetrics/calcIntakeMetrics'
import { media } from '../../utils/media'
import ReactDOM from 'react-dom'

const trackPrint = (window as any).trackPrint

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

interface IProps extends RouteComponentProps<{ screenNo: string }> {
  contents: ListContentsQuery_listContents[]
  intake: GetOwnIntakeQuery_getOwnIntake
}

interface IPrintProps {
  intake: GetOwnIntakeQuery_getOwnIntake
}

// Make typescript happy
declare var $: any

const SECTION_PAGES_STOP_PREV = [
  '01','19', '30', '38',// webtips
  'webinfo-01', 'webinfo-06',  'webinfo-12', 'webinfo-18',
]
const SECTION_PAGES_STOP_NEXT = [
  '16','28', '35', '63',
  'webinfo-05', 'webinfo-11',  'webinfo-17', 'webinfo-24',
]

const calcSectionNumber = (page: string = '') => {
  if (page.includes('webinfo')) {
    const pageNumber = parseInt(page.split('webinfo-')[1], 10)

    if (pageNumber <= 5) {
      return 1
    } else if (pageNumber <= 11) {
      return 2
    } else if (pageNumber <= 17) {
      return 3
    } else {
      return 4
    }
  } else if (!Number.isNaN(parseInt(page, 10))) {
    const pageNumber = parseInt(page, 10)
    if (pageNumber <= 16) {
      return 1
    } else if (pageNumber <= 28) {
      return 2
    } else if (pageNumber <= 35) {
      return 3
    } else if (pageNumber <= 64) {
      return 4
    } else {
      return 5
    }
  } else {
    return 1
  }
}

@observer
class ContentsManagerInner extends React.Component<IProps> {
  public componentDidUpdate() {
    this.enableTooltips()
    setTimeout(() => {
      (window as any).initializeVideos()
      this.enableSlideshow()
      this.enableSlideshow2()
    }, 500)

   if (document.getElementById('printSection')) {
     ReactDOM.render(<PrintSection intake={this.props.intake} />, document.getElementById('printSection'))
   }

    if (document.getElementById('printSection2')) {
      ReactDOM.render(<PrintSection2 />, document.getElementById('printSection2'))
    }
  }

  public componentDidMount() {
    (window as any).goTo = (path: string) => this.props.history.push(path)

    this.enableTooltips()
    setTimeout(() => {
      (window as any).initializeVideos()
      this.enableSlideshow()
      this.enableSlideshow2()
    }, 500)
   if (document.getElementById('printSection')) {
     ReactDOM.render(<PrintSection intake={this.props.intake} />, document.getElementById('printSection'))
   }

    if (document.getElementById('printSection2')) {
      ReactDOM.render(<PrintSection2 />, document.getElementById('printSection2'))
    }
  }

  public enableTooltips = () => {
    if (typeof $ === 'function') { $(() => $('[data-toggle="tooltip"]').tooltip({ html: true })) }
  }

  public enableSlideshow = () => {
    if (typeof $ === 'function') { $(() => {
      $('.slideshow').slick({
        accessibility: true,
        arrows: false,
        autoplay: true,
        dots: false,
        fade: true,
        speed: 500,
      })
      $('.slide-prev-btn').hide()
      $('.slide-prev-btn2').hide()
      $('.slide-next-btn').hide()
      $('.slide-next-btn2').hide()
      const children = $('.slideButtons:visible').children('')
      if (children.length > 0) {
        $(children[0]).show()
      }
    })
    }
  }

  public enableSlideshow2 = () => {
    if (window.location.href.includes('contents/57')) {
      (window as any).enableSlideshow2()
    }
  }

  public destroySlideshow = () => {
    if (typeof $ === 'function') { $(() => $('.slideshow').slick('unslick')) }
  }

  public render() {
    const content = this.getCurrentContent()

    if (!content) {
      return 'Content not found'
    }

    const { intake, match } = this.props
    const patientIntake = JSON.parse(localStorage.getItem('patientIntake')!)

    let Wrapper = Content
    if (content.noPadding) {
      Wrapper = ContentNoPadding
    }

    return (
      <Wrapper>
        <ContentsView screenNo={match.params.screenNo} content={content} intake={intake} patientIntake={patientIntake} />
        {(content.nextScreenNo || content.prevScreenNo) ?
          (
            <IntakeProgressBar
              count={this.calculateCount()}
              currentIndex={this.calculateCurrentIndex()}
              goToNext={content.nextScreenNo ? this.goToNext : null}
              goToPrev={content.prevScreenNo ? this.goToPrev : null}
            />
          ) : null}
          {/*<TrackPageview screenNo={match.params.screenNo} />*/}
      </Wrapper>
    )
  }

  private getCurrentContent = () => {
    const { match } = this.props
    return this.getContentByScreenNo(match.params.screenNo)
  }

  private getContentByScreenNo = (screenNo: string) => {
    const { contents, intake} = this.props

    const {
      parentAnxiety,
      parentCoping,
      parentSimpatia,
      parentFamilioso,
      parentReligiosity,
    } = intakeMetrics(intake)

    let type = parentAnxiety === 'L' ? 'LOW ' : 'HIGH '
    type += parentCoping === 'M' ?  'MONITOR' : 'BLUNTER'

    if(parentSimpatia === 'H'){
      type += 'SIMPATIA'
    }

    if(parentReligiosity === 'H'){
      type += 'RELIGIOSITY'
    }

    if(parentFamilioso === 'H'){
      type += 'FAMILIOSO'
    }


    return contents.find(con => {
      if (con.screenNo !== screenNo) { return false }
      if (con.parentAnxiety !== 'ALL') {
        if (parentAnxiety === 'L' && con.parentAnxiety !== 'LOW') { return false }
        if (parentAnxiety === 'H' && con.parentAnxiety !== 'HIGH') { return false }
      }
      if (con.parentCoping !== 'ALL') {
        if (parentCoping === 'M' && con.parentCoping !== 'MONITOR') { return false }
        if (parentCoping === 'B' && con.parentCoping !== 'BLUNTER') { return false }
      }
      if(con.parentSimpatia === 'HIGH'){
        if(parentSimpatia === 'H'){
          return true
        }else{
          return false
        }
      }
      if(con.parentFamilioso === 'HIGH'){
        if(parentFamilioso === 'H'){
          return true
        }else{
          return false
        }
      }
      if(con.parentReligiosity === 'HIGH'){
        if(parentReligiosity === 'H'){
          return true
        }else{
          return false
        }
      }
      return true
    })
  }

  private goToPrev = () => {
    const content = this.getCurrentContent()

    if (content && content.screenNo === 'HCP1-2') {
      const intake = JSON.parse(localStorage.getItem('patientIntake')!)

      const {
        surgeryOptions,
      } = intakeMetrics(intake)

      if (surgeryOptions === 'P' || surgeryOptions === 'PM') {
        this.props.history.push('HCP1-1c')
      } else {
        this.props.history.push('HCP1-1b')
      }

      window.scrollTo(0,0)
      return
    }


    if (!content || !content.prevScreenNo) { return }
    this.props.history.push(evaled(this.props.intake, content.id, content.prevScreenNo))
    window.scrollTo(0,0)
  }

  private goToNext = () => {
    const content = this.getCurrentContent()

    const intake = JSON.parse(localStorage.getItem('patientIntake')!)

    if (content && content.screenNo === 'HCP1-1b') {

      const {
        surgeryOptions,
      } = intakeMetrics(intake)

      if (surgeryOptions === 'P' || surgeryOptions === 'PM') {
        this.props.history.push('HCP1-1c')
      } else {
        this.props.history.push('HCP1-2')
      }
      window.scrollTo(0,0)
      return
    }


    if (!content || !content.nextScreenNo) { return }
    this.props.history.push(evaled(this.props.intake, content.id, content.nextScreenNo))
    window.scrollTo(0,0)
  }


  private calculateCount= () => {
    const content = this.getCurrentContent()

    if (content && (
      content.screenNo === 'HCP1-1a'  ||
      content.screenNo === 'HCP1-1b'  ||
      content.screenNo === 'HCP1-1c'  ||
      content.screenNo === 'HCP1-2'  ||
      content.screenNo === 'HCP1-3'  ||
      content.screenNo === 'HCP1-4'
    )) {

      const intake = JSON.parse(localStorage.getItem('patientIntake')!)

      const {
        surgeryOptions,
      } = intakeMetrics(intake)

      if (surgeryOptions === 'P' || surgeryOptions === 'PM') {
        return 7
      } else {
        return 6
      }
    }

    return this.calculateNextPages() + this.calculateCurrentIndex() + 1
  }

  private calculateCurrentIndex = () => {
    const content = this.getCurrentContent()

    console.log(content)


    if (content && (
      content.screenNo === 'HCP1-2'  ||
      content.screenNo === 'HCP1-3'  ||
      content.screenNo === 'HCP1-4' ||
      content.screenNo === 'HCP1-1a' ||
      content.screenNo === 'HCP1-1b' ||
      content.screenNo === 'HCP1-1c'
    )) {

      if (content.screenNo === 'HCP1-1a') {
        return 1
      } else if (content.screenNo === 'HCP1-1b') {
        return 2
      } else if (content.screenNo === 'HCP1-1c') {
        return 3
      }

      let pageNumber = 3

      if ( content.screenNo === 'HCP1-3') {
        pageNumber = 4
      } else if (content.screenNo === 'HCP1-4') {
        pageNumber = 5
      }

      const intake = JSON.parse(localStorage.getItem('patientIntake')!)
      const {
        surgeryOptions,
      } = intakeMetrics(intake)


      if (surgeryOptions === 'P' || surgeryOptions === 'PM') {
        return pageNumber + 1
      } else {
        return pageNumber
      }
    }


    let counter = 0
    let newContent = content
    while (
      content &&
      newContent &&
      newContent.prevScreenNo.length > 0 &&
      calcSectionNumber(content.screenNo) === calcSectionNumber(newContent.screenNo)
    ) {

      const prevScreen = evaled(this.props.intake, newContent.id, newContent.prevScreenNo)
      console.log(prevScreen)
      newContent = this.getContentByScreenNo(prevScreen)

      console.log(newContent)
      if (content && newContent && calcSectionNumber(content.screenNo) === calcSectionNumber(newContent.screenNo)) {
        console.log('add to counter')
        counter++
      } else {
        break
      }

      if (counter > 100) {
        console.log('INFINITE LOOP')
        break
      }

    }


    if (content && (
      content.screenNo.includes('HCP3')
    )) {
      return counter + 1
    }

    console.log(counter)
    return counter
  }

  private calculateNextPages  = () => {
    const content = this.getCurrentContent()


    let counter = 0
    let newContent = content
    while (
      content &&
      newContent &&
        newContent.nextScreenNo &&
      newContent.nextScreenNo.length > 0 &&
      calcSectionNumber(content.screenNo) === calcSectionNumber(newContent.screenNo)
    ) {

      const nextScreen = evaled(this.props.intake, newContent.id, newContent.nextScreenNo)
      newContent = this.getContentByScreenNo(nextScreen)

      if (content && newContent && calcSectionNumber(content.screenNo) === calcSectionNumber(newContent.screenNo)) {
        counter++
      } else {
        break
      }

      console.log('next Screen', nextScreen)
      if (counter > 100) {
        console.log('INFINITE LOOP')
        break
      }

    }

    return counter
  }
}


const PrintSection2 = () => {

  const baseURL = 'https://uci-images.s3-us-west-1.amazonaws.com/summaries/WebTIPS-'
  const link1 = <li className="list-item tick1"><a href={'https://uci-images.s3-us-west-1.amazonaws.com/downloads/PackingList_ES.pdf'} target="_blank" onClick={(event) => {
    if ( isMobile ) {
      event!.preventDefault()
    }
    trackPrint('https://uci-images.s3-us-west-1.amazonaws.com/downloads/PackingList_ES.pdf','Section1')
    // @ts-ignore
    if(window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        name: 'downloadPdf',
        link: `https://uci-images.s3-us-west-1.amazonaws.com/downloads/PackingList_ES.pdf`,
      }), '*')
    }
  }}>{lang === 'es' ? 'Lista de cosas para llevar al hospital' : 'Home & Before Surgery (1A)'}</a></li>

  const link2 = <li className="list-item tick2"><a href={'https://uci-images.s3-us-west-1.amazonaws.com/downloads/DistractionIdeas_ES.pdf'} target="_blank" onClick={(event) => {
    if ( isMobile ) { event!.preventDefault() }
    trackPrint('https://uci-images.s3-us-west-1.amazonaws.com/downloads/DistractionIdeas_ES.pdf','Section1')
    // @ts-ignore
    if(window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        name: 'downloadPdf',
        link: `https://uci-images.s3-us-west-1.amazonaws.com/downloads/DistractionIdeas_ES.pdf`,
      }), '*')
    }
  }}>{lang === 'es' ? 'Ideas para distraerse' : 'Home & Before Surgery (1A)'}</a></li>

  const link3 = <li className="list-item tick3"><a href={'https://uci-images.s3-us-west-1.amazonaws.com/downloads/Actividades.zip'} target="_blank" onClick={(event) => {
    if ( isMobile ) { event!.preventDefault() }
    trackPrint('https://uci-images.s3-us-west-1.amazonaws.com/downloads/Actividades.zip','Section1')
    // @ts-ignore
    if(window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        name: 'downloadPdf',
        link: `https://uci-images.s3-us-west-1.amazonaws.com/downloads/Actividades.zip`,
      }), '*')
    }
  }}>{lang === 'es' ? 'Actividades' : 'Home & Before Surgery (1A)'}</a></li>

  const link4 = <li className="list-item tick4"><a href={'https://uci-images.s3-us-west-1.amazonaws.com/downloads/ColoringPages_ES.pdf'} target="_blank" onClick={(event) => {
    if ( isMobile ) { event!.preventDefault() }
    trackPrint('https://uci-images.s3-us-west-1.amazonaws.com/downloads/ColoringPages_ES.pdf','Section1')
    // @ts-ignore
    if(window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        name: 'downloadPdf',
        link: `https://uci-images.s3-us-west-1.amazonaws.com/downloads/ColoringPages_ES.pdf`,
      }), '*')
    }
  }}>{lang === 'es' ? 'Páginas para colorear' : 'Home & Before Surgery (1A)'}</a></li>
  const link5 = <li className="list-item tick5"><a href={'https://uci-images.s3-us-west-1.amazonaws.com/downloads/HospitalMap-CHOC_ES.pdf'} target="_blank" onClick={(event) => {
    if ( isMobile ) { event!.preventDefault() }
    trackPrint('https://uci-images.s3-us-west-1.amazonaws.com/downloads/HospitalMap-CHOC_ES.pdf','Section1')
    // @ts-ignore
    if(window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        name: 'downloadPdf',
        link: `https://uci-images.s3-us-west-1.amazonaws.com/downloads/HospitalMap-CHOC_ES.pdf`,
      }), '*')
    }
  }}>{lang === 'es' ? 'Mapa del hospital' : 'Home & Before Surgery (1A)'}</a></li>


  return(
    <ul className="list">
      {link1}
      {link2}
      {link3}
      {link4}
      {link5}
    </ul>
  )
}

const PrintSection = ({intake} : IPrintProps) => {

    const {
      parentAnxiety,
      parentCoping,
      surgeryOptions,
      section2Started,
      section3Started,
      section4Started,
      section4ReviewCompleted,
    } = intakeMetrics(intake)


    let section1 = null
    const baseURL = 'https://uci-images.s3-us-west-1.amazonaws.com/summaries/WebTIPS-'


    if (section2Started) {
      if (parentAnxiety === 'H') {
        section1 = <li className="list-item tick1"><a href={`${baseURL}Section1-A${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section1.pdf','Section1')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section1-A${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
        }}>{lang === 'es' ? 'En casa antes de la cirugía (1A)' : 'Home & Before Surgery (1A)'}</a></li>
      } else {
        section1 = <li className="list-item tick1"><a href={`${baseURL}Section1-B${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section1.pdf','Section1')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section1-B${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
          }}>{lang === 'es' ? 'En casa antes de la cirugía (1A)' : 'Home & Before Surgery (1B)'}</a></li>
      }
    }

    let section2 = null

    if (section3Started) {
      if (surgeryOptions === 'N') {
        section2 = <li className="list-item tick2"><a href={`${baseURL}Section2-A${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section2.pdf','Section2')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section2-A${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
        }}>El día de la cirugía (S2A)</a></li>
      } else if ( surgeryOptions === 'M') {
        section2 = <li className="list-item tick2"><a href={`${baseURL}Section2-B${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section2.pdf','Section2')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section2-B${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
         }}>El día de la cirugía (S2B)</a></li>
      } else if ( surgeryOptions === 'P') {
        section2 = <li className="list-item tick2"><a href={`${baseURL}Section2-C${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section2.pdf','Section2')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section2-C${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
        }}>El día de la cirugía (S2C)</a></li>
      } else if ( surgeryOptions === 'PM') {
        section2 = <li className="list-item tick2"><a href={`${baseURL}Section2-D${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section2.pdf','Section2')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section2-D${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
        }}>El día de la cirugía (S2D)</a></li>
      }
    }

    let section3 = null

    if (section4Started) {
      if (parentCoping === 'M') {
        section3 = <li className="list-item tick3"><a href={`${baseURL}Section3-A${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section3.pdf','Section3')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section3-A${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
         }}>Sala de recuperación (3A)</a></li>
      } else {
        section3 = <li className="list-item tick3"><a href={`${baseURL}Section3-B${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
          if ( isMobile ) { event!.preventDefault() }
          trackPrint('Section3.pdf','Section3')
          // @ts-ignore
          if(window.ReactNativeWebView){
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section3-B${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
          }
        }}>Sala de recuperación (3B)</a></li>
      }
    }

    let section4 = null

    if (section4ReviewCompleted) {
      section4 = <li className="list-item tick4"><a href={`${baseURL}Section4-${intake.surgeryType}${lang === 'es' ? '_ES' : ''}.pdf`} target="_blank" onClick={(event) => {
        if ( isMobile ) { event!.preventDefault() }
        trackPrint('Section4.pdf','Section4')
        // @ts-ignore
        if(window.ReactNativeWebView){
          // @ts-ignore
          window.ReactNativeWebView.postMessage(JSON.stringify({name:'downloadPdf', link:`${baseURL}Section4-${intake.surgeryType}${lang === 'es' ? '_ES' : ''}.pdf`}), '*')
        }
      }}>En casa después de la cirugía</a></li>
    }

  return (
    <ul className="list">
      {section1}
      {section2}
      {section3}
      {section4}
    </ul>
  )
}

export const ContentsManager = withRouter(ContentsManagerInner)

function evaled (intake: GetOwnIntakeQuery_getOwnIntake, id: string, str: string) {
  const {
    childAnxiety,
    intake1Started,
    intake2Started,
    intake3Started,
    intake3AllUnsureDontKnow,
    parentAnxiety,
    parentCoping,
    parentReligiosity,
    parentFamilioso,
    parentSimpatia,
    section1Started,
    section2Started,
    section3Started,
    surgeryOptions,
    section4Started,
    section4ReviewCompleted,
  } = intakeMetrics(intake)

  if (childAnxiety || parentAnxiety || parentCoping || section2Started || intake1Started || intake2Started ||
    section1Started || section3Started || intake3Started || section4Started || intake3AllUnsureDontKnow ||
    section4ReviewCompleted || parentReligiosity || parentFamilioso || parentSimpatia ) { /* Make typescript happy */ }

  if (!str.startsWith('if')) {
    return str
  }

  try {
    // tslint:disable-next-line:no-eval
    const result = eval(`(() => { ${str} })()`)

    // tslint:disable-next-line:no-console
    // console.log('got result', result)

    return result
  } catch (e) {
    throw new Error(`Could not eval content str '${str}' for id ${id}: ${e}`)
  }
}



const ContentNoPadding = styled.div`
  flex: 1 0 auto;
  display: flex;
  width: 100%;
  font-size: 18px;
  color: #172129;
  line-height: 24px;
  white-space: pre-line;

  h1 {
    font-family: Nunito;
    font-size: 26px;
    font-weight: 900;
    color: #12385b;
    text-align: center;
    margin-bottom: 18px;

    ${media.tablet`
      font-size: 54px;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/organisms/Contents/ContentsManager.tsx